<template>
  <base-card
    class="mt-3 mb-2 clickable position-relative"
    condensed
    @click.native="$emit('view', item)"
  >
    <base-icon
      icon="close-x"
      class="delete-button position-absolute pull-right"
      @click.native.stop="$emit('delete', item)"
    />
    <div class="d-flex w-100 appointment-cell__container">
      <div class="thumb mr-2">
        <template v-if="thumbs.length > 0">
          <img
            v-for="(image, index) in thumbs"
            :key="`image_thumb_${index}`"
            :src="`${image.product.thumb}?w=198&h=306&fit=fill&fill=solid`"
            :style="`margin-left: ${index === 0 ? 0 : 5}px`"
          >
        </template>
        <template v-else>
          <div class="d-flex">
            <div
              class="empty-item mr-2"
            />
            <div
              class="empty-item"
            />
          </div>
        </template>
      </div>
      <div class="w-100">
        <div class="w-100 h-100 d-flex flex-column justify-content-start py-2 pl-4">
          <div class="w-100">
            <base-text medium>
              {{ item.start_date | nicedate('custom', 'MMMM DD hh:mmA zz') }}
              <base-tooltip
                v-if="!past"
                text="Add to Calendar"
              >
                <base-icon
                  icon="schedule"
                  class="clickable ml-3"
                  @click.native.stop="downloadICS"
                />
              </base-tooltip>
            </base-text>
            <base-text medium>
              {{ item.subject }}
              <base-tooltip
                v-if="hasJoinLink && !past"
                :text="tooltipText"
              >
                <base-icon
                  icon="create-link"
                  class="clickable ml-3"
                  @click.native.stop="copyLinkToClipboard"
                />
              </base-tooltip>
            </base-text>
            <!-- Appointment duration -->
            <div
              v-if="duration !== null && past && !inPerson && !recommendation"
              class="d-flex duration justify-content-center"
            >
              <base-text
                size="s"
              >
                {{ duration }}
              </base-text>
            </div>
          </div>
          <div class="details mt-2">
            <div>
              <span class="label">Appointment Type</span>
              <span class="value">{{ typeLabel | capitalize }}</span>
            </div>
            <div><span class="label">Products</span><span class="value">{{ item.products.length }}</span></div>
            <div class="d-flex">
              <span class="label">Invites</span>
              <div class="d-flex w-100 justify-content-between">
                <span class="value">{{ displayCustomers(item.customers) }}</span>
                <base-button
                  v-if="buttonJoin && hasJoinLink"
                  small
                  class="appointment-cell__button"
                  @click="openInNewTab(item.join_link)"
                >
                  {{ !responsive.lg? 'Join' : 'Join Appointment' }}
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </base-card>
</template>
<script>

import { APPOINTMENT_TYPES } from '@/_utilities/Enums';
import responsive from '@/components/mixins/responsive';

export const [SCHEDULED, CANCELLED, FINISHED] = [0, 1, 2];

export default {
  name: 'AppointmentsCell',
  mixins: [
    responsive,
  ],
  props: {
    item: {
      type: Object,
      required: true,
    },
    buttonJoin: {
      type: Boolean,
      default: true,
    },
    past: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tooltipText: 'Copy Link',
      APPOINTMENT_TYPES,
    };
  },
  computed: {
    status() {
      switch (this.item.status) {
        case SCHEDULED:
          return '(Scheduled)';
        case CANCELLED:
          return '(Cancelled)';
        case FINISHED:
          return '(Finished)';
        default:
          return '';
      }
    },
    thumbs() {
      return this.item.products.slice(0, 2);
    },
    duration() {
      let duration = '';
      if (this.item.duration?.hours) {
        duration += `${this.item.duration.hours}h `;
      }
      duration += this.item.duration ? `${this.item.duration.minutes}m` : '--';
      return duration;
    },
    typeLabel() {
      return Object.entries(APPOINTMENT_TYPES)
        .find(([key, value]) => value === this.item.appointment_type)[0]
        .replace('_', ' ').toLowerCase();
    },
    inPerson() {
      return this.item.appointment_type === APPOINTMENT_TYPES.IN_PERSON;
    },
    recommendation() {
      return this.item.appointment_type === APPOINTMENT_TYPES.RECOMMENDATION;
    },
    hasJoinLink() {
      return !this.inPerson && !this.recommendation;
    },
  },
  methods: {
    displayCustomers(customers) {
      if (customers.length === 1) {
        return `${customers[0].first_name} ${customers[0].last_name}`;
      }
      return `${customers.length} clients`;
    },
    downloadICS(item) {
      this.$store.dispatch('appointments/downloadICS', this.item.pk).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        const fname = `${this.item.subject.replaceAll(' ', '-')}.ics`;
        fileLink.setAttribute('download', fname);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
      });
    },
    copyLinkToClipboard() {
      this.tooltipText = 'Copied!';
      window.Clipboard.copy(this.item.invite_link);
      setTimeout(() => {
        this.tooltipText = 'Copy Link';
      }, 30000);
    },
  },
};
</script>
<style lang="scss"
  scoped>
::v-deep .card-body {
  border: 1px #D4D4D4 solid;
  border-radius: 5px;
}

.details {
  font-size: 12px;
  color: grey;

  >div {
    margin-top: 5px;
  }

  .label {
    text-transform: uppercase;
    display: inline-block;
    min-width: 135px;
  }

  .value {
    font-family: $font-family-sans-serif-semibold;
  }
}

.thumb {
  height: 153px;
  width: 210px; //calc(99px + 99px + 5px);
  display: flex;
  /*
  justify-content: center;
  align-items: center;*/

  img {
    flex-shrink: 0;
    /* min-width: 100%;
    min-height: 100%; */
    height: 153px;
    width: 99px;
    object-fit: cover;
  }

  /*img {
    margin-top: auto;
    margin-bottom: auto;
    display: block;
    max-width:153px;
    max-height:99px;
    width: auto;
    height: auto;
    object-fit: contain;

  }*/
}

.clickable {
  cursor: pointer;
}
.delete-button {
  top: 17px;
  right: 17px;
  width: 16px;
  height: 16px;
  z-index: 19;
}
.appointment-cell{
  &__container{
    position: relative;
  }
  &__button{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}

.empty-item {
  background: #F5EFEB;
  width: 75px;
  height: 147px;
}

.duration {
  background: #F2F1EE;
  font-size: 10px;
  width: 70px;
}
</style>
